__webpack_require__.p = "https://s3.eu-west-2.amazonaws.com/polygonjs-assets/1_1_253__editor__1_1_253-1_/";